import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const projectflowBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/projectflow/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const projectflowBaseUrl = baseDeployUrl + '/api/1.0/flow/projectflow/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getList = (params) => {
  return axios.request({
    url: projectflowBaseUrl + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const saveProjectflow = (data) => {
  return axios.request({
    url: projectflowBaseUrl + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const getProjectFlowDetail = (params) => {
  return axios.request({
    url: projectflowBaseUrl + params.id,
    headers: baseHeaders,
    method: 'get'
  })
}

export const cancelProjectflow = (id) => {
  return axios.request({
    url: projectflowBaseUrl + id,
    headers: baseHeaders,
    method: 'delete'
  })
}
